import { Dialog, DialogContent, DialogOverlay, DialogPortal } from '@hqo/ui-atoms';
import * as React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const Modal = ({ isOpen, onClose, children }: ModalProps) => (
  <Dialog open={isOpen} onOpenChange={onClose}>
    <DialogPortal>
      <DialogOverlay />
      <DialogContent>
        {children}
      </DialogContent>
    </DialogPortal>
  </Dialog>
);
